import styled, { css } from "styled-components";
import {
  CARTAZ_PEQUENO,
  CARTAZ_PEQUENO_DIM,
  PANFLETO_DIM,
} from "../../EncarteConstants";

export const CanvasContainer = styled.div`
  width: ${({ canvasScale }) => PANFLETO_DIM.width * canvasScale}px;
  height: ${({ canvasScale }) => PANFLETO_DIM.height * canvasScale}px;
  background: #fff;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  margin-top: 3rem;
  @media print {
    margin-top: 0;
  }
  position: relative;
  z-index: 0;
  box-shadow: 0 20px 20px 5px rgba(1, 1, 1, 0.1);
`;

const CartazPequenoGridStyles = css`
  grid-template-rows: repeat(
    ${({ rows }) => rows},
    ${({ canvasScale }) => CARTAZ_PEQUENO_DIM.width * canvasScale}px
  );
  grid-template-columns: repeat(
    ${({ columns }) => columns},
    ${({ canvasScale }) => CARTAZ_PEQUENO_DIM.height * canvasScale}px
  );
  align-items: center;
  justify-items: center;
`;

export const Grid = styled.div`
  gap: ${({ canvasScale }) => 10 * canvasScale}px;
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-template-rows: repeat(${({ rows }) => rows}, 1fr);

  ${({ styles }) => styles.format === CARTAZ_PEQUENO && CartazPequenoGridStyles}
`;
